import { useMappingFiltersStore } from '../stores/mappingFiltersStore';

export const useMappingFilters = () => {
  const filters = useMappingFiltersStore((state) => state.filters);
  const setFilters = useMappingFiltersStore((state) => state.setFilters);
  const updateFilters = useMappingFiltersStore((state) => state.updateFilters);
  const setFilter = useMappingFiltersStore((state) => state.setFilter);
  const removeFilter = useMappingFiltersStore((state) => state.removeFilter);
  const clearFilters = useMappingFiltersStore((state) => state.clearFilters);
  const getFilter = useMappingFiltersStore((state) => state.getFilter);
  const hasFilters = useMappingFiltersStore((state) => state.hasFilters());
  const hasFilter = useMappingFiltersStore((state) => state.hasFilter);

  const setMarketplaceFilter = (value) => setFilter('marketplace', value);
  const setStoreFilter = (value) => setFilter('store', value);
  const setMPCategoryFilter = (value) => setFilter('mpCategory', value);

  return {
    filters,
    setFilters,
    updateFilters,
    setFilter,
    removeFilter,
    clearFilters,
    getFilter,
    hasFilters,
    hasFilter,
    setMarketplaceFilter,
    setStoreFilter,
    setMPCategoryFilter,
  };
};
